// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"crriR","sticky-editorx":"rWuvh","stickyEditorx":"rWuvh"};